module.exports = __webpack_public_path__ + "img/普瑞眼科.55eccfe.png";